import BaseDataObject from './BaseDataObject';
import BaseReduction from './BaseReduction';

export default class TrendReduction extends BaseReduction {
  constructor() {
    super(...arguments);
    this.ensureInteger('minNegativeTrend', -1);
    this.ensureInteger('maxNegativeTrend', -1);
    this.ensureInteger('minPositiveTrend', -1);
    this.ensureInteger('maxPositiveTrend', -1);
    this.ensureInteger('trendMinutes', 30);
    this.ensureArray('winnersIncreasedPercent');
    this.ensureArray('winnersDecreasedPercent');
  }

  isEmpty() {
    let num, n;

    if (this.getMinNegativeTrend() > 0) {
      return false;
    }
    if (this.getMaxNegativeTrend() >= 0) {
      return false;
    }
    if (this.getMinPositiveTrend() > 0) {
      return false;
    }
    if (this.getMaxPositiveTrend() > 0) {
      return false;
    }

    num = this.getNumberOfWinnersIncreasedPercent();
    for (n = 0; n < num; n++) {
      if (!this.getWinnersIncreasedPercent(n).isEmpty()) {
        return false;
      }
    }

    num = this.getNumberOfWinnersDecreasedPercent();
    for (n = 0; n < num; n++) {
      if (!this.getWinnersDecreasedPercent(n).isEmpty()) {
        return false;
      }
    }

    return true;
  }
  /**/
  getTrendMinutes() {
    return this.getInteger('trendMinutes', 30);
  }

  setTrendMinutes(v) {
    this.invalidate();
    return this.setInteger('trendMinutes', v);
  }
  getMinNegativeTrend() {
    return this.getInteger('minNegativeTrend', -1);
  }

  getMaxNegativeTrend() {
    return this.getInteger('maxNegativeTrend', -1);
  }

  getMinPositiveTrend() {
    return this.getInteger('minPositiveTrend', -1);
  }

  getMaxPositiveTrend() {
    return this.getInteger('maxPositiveTrend', -1);
  }

  setMinNegativeTrend(v) {
    this.invalidate();
    return this.setInteger('minNegativeTrend', v);
  }

  setMaxNegativeTrend(v) {
    this.invalidate();
    return this.setInteger('maxNegativeTrend', v);
  }

  setMinPositiveTrend(v) {
    this.invalidate();
    return this.setInteger('minPositiveTrend', v);
  }

  setMaxPositiveTrend(v) {
    this.invalidate();
    return this.setInteger('maxPositiveTrend', v);
  }

  getNumberOfWinnersIncreasedPercent() {
    return this.getNumberOf('winnersIncreasedPercent');
  }

  getNumberOfWinnersDecreasedPercent() {
    return this.getNumberOf('winnersDecreasedPercent');
  }

  /**/
  getWinnersIncreasedPercent(index) {
    return this.getObject(
      'winnersIncreasedPercent',
      TrendReductionWinnersIncreasePercent,
      index,
    );
  }

  getWinnersDecreasedPercent(index) {
    return this.getObject(
      'winnersDecreasedPercent',
      TrendReductionWinnersDecreasedPercent,
      index,
    );
  }

  /**/
  getAllWinnersIncreasedPercent() {
    return this.getObjects(
      'winnersIncreasedPercent',
      TrendReductionWinnersIncreasePercent,
    );
  }

  getAllWinnersDecreasedPercent() {
    return this.getObjects(
      'winnersDecreasedPercent',
      TrendReductionWinnersDecreasedPercent,
    );
  }

  /**/
  addWinnersNegative() {
    this.invalidate();
    return this.addObject('winnersNegative', TrendReductionWinnersNegative);
  }

  addWinnersPositive() {
    this.invalidate();
    return this.addObject('winnersPositive', TrendReductionWinnersPositive);
  }

  addWinnersIncreasedPercent() {
    this.invalidate();
    return this.addObject(
      'winnersIncreasedPercent',
      TrendReductionWinnersIncreasePercent,
    );
  }

  addWinnersDecreasedPercent() {
    this.invalidate();
    return this.addObject(
      'winnersDecreasedPercent',
      TrendReductionWinnersDecreasedPercent,
    );
  }

  /**/
  deleteWinnersNegative(index) {
    this.invalidate();
    return this.deleteObject('winnersNegative', index);
  }

  deleteWinnersPositive(index) {
    this.invalidate();
    return this.deleteObject('winnersPositive', index);
  }

  deleteWinnersIncreasedPercent(index) {
    this.invalidate();
    return this.deleteObject('winnersIncreasedPercent', index);
  }

  deleteWinnersDecreasedPercent(index) {
    this.invalidate();
    return this.deleteObject('winnersDecreasedPercent', index);
  }
}

class TrendReductionWinnersNegative extends BaseDataObject {
  constructor() {
    super(...arguments);
    this.ensureInteger('min', -1);
    this.ensureInteger('max', -1);
  }

  isEmpty() {
    return this.getMin() === -1 && this.getMax() === -1 ? true : false;
  }

  getMin() {
    return this.getInteger('min', -1);
  }

  setMin(v) {
    this.invalidate();
    return this.setInteger('min', v);
  }

  getMax() {
    return this.getInteger('max', -1);
  }

  setMax(v) {
    this.invalidate();
    return this.setInteger('max', v);
  }
}

class TrendReductionWinnersPositive extends BaseDataObject {
  constructor() {
    super(...arguments);
    this.ensureInteger('min', -1);
    this.ensureInteger('max', -1);
  }

  isEmpty() {
    return this.getMin() === -1 && this.getMax() === -1 ? true : false;
  }

  getMin() {
    return this.getInteger('min', -1);
  }

  setMin(v) {
    this.invalidate();
    return this.setInteger('min', v);
  }

  getMax() {
    return this.getInteger('max', -1);
  }

  setMax(v) {
    this.invalidate();
    return this.setInteger('max', v);
  }
}

class TrendReductionWinnersIncreasePercent extends BaseDataObject {
  constructor() {
    super(...arguments);
    this.ensureInteger('min', -1);
    this.ensureInteger('max', -1);
    this.ensureInteger('percentagePoint', -1);
  }

  isEmpty() {
    return this.getMin() === -1 && this.getMax() === -1 ? true : false;
  }

  getMin() {
    return this.getInteger('min', -1);
  }

  setMin(v) {
    this.invalidate();
    return this.setInteger('min', v);
  }

  getMax() {
    return this.getInteger('max', -1);
  }

  setMax(v) {
    this.invalidate();
    return this.setInteger('max', v);
  }

  getPercentagePoint() {
    return this.getInteger('percentagePoint', -1);
  }

  setPercentagePoint(v) {
    this.invalidate();
    this.setInteger('percentagePoint', v);
  }
}

class TrendReductionWinnersDecreasedPercent extends BaseDataObject {
  constructor() {
    super(...arguments);
    this.ensureInteger('min', -1);
    this.ensureInteger('max', -1);
    this.ensureInteger('percentagePoint', -1);
  }

  isEmpty() {
    return this.getMin() === -1 && this.getMax() === -1 ? true : false;
  }

  getMin() {
    return this.getInteger('min', -1);
  }

  setMin(v) {
    this.invalidate();
    return this.setInteger('min', v);
  }

  getMax() {
    return this.getInteger('max', -1);
  }

  setMax(v) {
    this.invalidate();
    return this.setInteger('max', v);
  }

  getPercentagePoint() {
    return this.getInteger('percentagePoint', -1);
  }

  setPercentagePoint(v) {
    this.invalidate();
    this.setInteger('percentagePoint', v);
  }
}
